import { Stack, HoverCard } from '@mantine/core';
import { RedactionMatchPreviewProps } from './types';
import * as classes from './styles/index.css';
import { REDACTION_MATCH_PREVIEW_WIDTH } from './styles/variables';
import ResourceBadge from '@app/features/Resource/ResourceBadge';
import RedactionMatchPreviewContent from '../RedactionMatchPreviewContent';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function RedactionMatchPreview({
  match,
  matches,
  target,
  resource,
  ...props
}: RedactionMatchPreviewProps) {
  const matchData = matches ?? [match];

  return (
    <HoverCard
      width={REDACTION_MATCH_PREVIEW_WIDTH}
      shadow="sm"
      withinPortal
      zIndex={500}
      closeDelay={0}
      {...props}
    >
      <HoverCard.Target>{target}</HoverCard.Target>
      <HoverCard.Dropdown className={classes.redactionMatchPreview}>
        <Stack gap={0}>
          {resource ? (
            <ResourceBadge
              className={classes.resourceBadgeBox}
              resource={resource}
            />
          ) : null}
          <Stack gap={0}>
            {matchData.map((data, index) => (
              <RedactionMatchPreviewContent
                key={index}
                match={data}
                showPageIndex
              />
            ))}
          </Stack>
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

export default RedactionMatchPreview;
